import React, { useState, useEffect } from "react";
import { Select, Descriptions, Flex, Space, Table, Typography } from "antd";
import { TagOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axiosInstance from "utilities/axios";
import useRoleCheck from "utilities/hooks/roleCheck";

const { Text } = Typography;
function TransferRequest({ value, onChange }) {
  //This compontent uses three dropdowns to return the integer for the selected equipment type
  const { clinic_no } = useParams();
  const { hasPermission } = useRoleCheck();

  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [selectedEquipmentItem, setSelectedEquipmentItem] = useState(null);

  const categoryOptions = Array.from(
    new Set(equipmentOptions.map((e) => e.category))
  );
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [availableEquipment, setAvailableEquipment] = useState([]);

  const roundDistance = (distance) => {
    return distance < 10 ? distance.toFixed(1) : distance.toFixed(0);
  };

  const columns = [
    {
      title: "Brand",
      dataIndex: ["equipment", "brand"],
      key: "brand",
    },
    {
      title: "Model",
      dataIndex: ["equipment", "model"],
      key: "model",
    },
    {
      title: "Clinic No",
      dataIndex: "clinicNo",
      key: "clinicNo",
    },
    {
      title: "Distance (KM)",
      dataIndex: "distance",
      key: "distance",
      render: (text) => `${roundDistance(text)} km`,
    },
  ];

  useEffect(() => {
    axiosInstance.get("/equipment?orderableItem=true").then((result) => {
      const nonAudioEquipmentCategories = ["Digital Signature Pad", "Barcode Scanner"];

      if (hasPermission(["Audiology.Admin", "Audiology.Write"])) {
        setEquipmentOptions(result.data.filter((e) => !nonAudioEquipmentCategories.includes(e.category)))
        return;
      }

      setEquipmentOptions(result.data);
    });
  }, []);

  useEffect(() => {
    const params = {
      category: selectedCategory,
      condition: "Working",
      status: "Not In Use",
      sort: "distance",
      refClinicNo: clinic_no,
    };
    if (selectedCategory) {
      axiosInstance.get("/equipment/inventory", { params }).then((result) => {
        setAvailableEquipment(result.data);
      });
    }
  }, [selectedCategory, clinic_no]);

  useEffect(() => {
    if (onChange) {
      onChange(selectedEquipmentItem?.id);
    }
  }, [selectedEquipmentItem, onChange]);

  return (
    <>
      <Flex align="center" style={{ marginBottom: "10px" }}>
        <Space size="small" style={{ paddingRight: "10px" }}>
          <TagOutlined /> Category
        </Space>
        <Select
          style={{ width: "100%" }}
          autoFocus
          onChange={(value) => {
            setSelectedCategory(value);
          }}
          placeholder="Select a category"
          defaultActiveFirstOption={false}
          options={categoryOptions.map((item) => ({
            value: item,
            label: item,
          }))}
        />
      </Flex>
      <Table
        locale={{
          emptyText: !!selectedCategory ? (
            <Space direction="vertical" align="center">
              <Text type="secondary">
                No equipment available in this category.
              </Text>
              <Text type="secondary">Please select a different category</Text>
            </Space>
          ) : (
            <Text type="secondary">Please select a category</Text>
          ),
        }}
        size="small"
        columns={columns}
        dataSource={availableEquipment}
        rowKey="id"
        onRow={(record) => ({
          onClick: () => {
            setSelectedEquipmentItem(record);
          },
        })}
        pagination={false}
        scroll={{ y: 240 }}
        rowSelection={{
          type: "radio",
          selectedRowKeys: selectedEquipmentItem
            ? [selectedEquipmentItem.id]
            : [],
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedEquipmentItem(selectedRows[0]);
          },
        }}
      />
      <InfoCircleOutlined style={{ marginLeft: "10px" }} />
      <Text italic type="secondary" style={{ marginLeft: "10px" }}>
        Listed Equipment is working and not in use at clinic.
      </Text>
      {selectedEquipmentItem && (
        <Descriptions
          size="small"
          bordered
          layout="vertical"
          style={{ marginTop: "16px", marginBottom: "0px" }}
        >
          <Descriptions.Item label="Date Added">
            {selectedEquipmentItem.dateAdded}
          </Descriptions.Item>
          <Descriptions.Item label="Regional Manager">
            {selectedEquipmentItem.rm.firstName}{" "}
            {selectedEquipmentItem.rm.lastName}
          </Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
}
export default TransferRequest;
